import FormHelperText from '@material-ui/core/FormHelperText';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

interface IHelperTextProps {
  message?: string;
  children?: never;
}

const HelperText: React.FunctionComponent<IHelperTextProps & WithTranslation> = ({ message, t }) => (
  <FormHelperText>
    <span>
      {message ? message : t('required')}
    </span>
  </FormHelperText>
);

const Translated = withTranslation()(HelperText);

export {
  Translated as HelperText
};
